



















import Vue, { PropType } from "vue";
import fetch from "cross-fetch";
declare const paypal: any;

export interface PaypalCustomCardFieldsData {
  doUseSettings: string;
  agreements: string[];
  needAgreementsAllowCount: number;
  isProcessing: boolean;
  isValid: boolean;
  formStyles: object;
  formFields: object;
  hostedFields: any;
}

export interface PaypalInputCardInformationFormProps {
  sdkUrl: string;
  purchaseApiUrl: string;
  errorUrl: string;
  clientToken: string;
  csrfToken: string;
  translationResources: object;
  requestBody: object;
}

export default Vue.extend({
  name: "vc-paypal-input-card-information-form",
  props: {
    sdkUrl: {
      type: String as PropType<PaypalInputCardInformationFormProps["sdkUrl"]>,
      default: ""
    },
    purchaseApiUrl: {
      type: String as PropType<
        PaypalInputCardInformationFormProps["purchaseApiUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<PaypalInputCardInformationFormProps["errorUrl"]>,
      default: ""
    },
    clientToken: {
      type: String as PropType<
        PaypalInputCardInformationFormProps["clientToken"]
      >,
      default: ""
    },
    csrfToken: {
      type: String as PropType<
        PaypalInputCardInformationFormProps["csrfToken"]
      >,
      default: ""
    },
    translationResources: {
      type: Object as PropType<
        PaypalInputCardInformationFormProps["translationResources"]
      >,
      default: () => {}
    },
    requestBody: {
      type: Object as PropType<
        PaypalInputCardInformationFormProps["requestBody"]
      >,
      default: () => {}
    }
  },
  data(): PaypalCustomCardFieldsData {
    return {
      doUseSettings: "1",
      needAgreementsAllowCount: 2,
      agreements: [],
      isProcessing: false,
      isValid: false,
      formStyles: {
        input: {
          "font-size": "12px",
          "font-family": "Product Sans",
          color: "#3a3a3a"
        },
        ":focus": {
          color: "black"
        },
        ".invalid": {
          color: "#FF0000"
        }
      },
      formFields: {
        number: {
          selector: "#card-number",
          placeholder: "Credit Card Number"
        },
        cvv: {
          selector: "#cvv",
          placeholder: "CVV"
        },
        expirationDate: {
          selector: "#expiration-date",
          placeholder: "MM/YYYY"
        }
      },
      hostedFields: {}
    };
  },
  mounted() {
    this.useSettings();
  },
  methods: {
    useSettings() {
      const purchaseApiUrl = this.purchaseApiUrl;
      const errorUrl = this.errorUrl;
      const csrfToken = this.csrfToken;
      const script = document.createElement("script");
      const self = this;

      script.src = this.sdkUrl;
      script.setAttribute("data-client-token", this.clientToken);
      script.onload = () => {
        // Check if card fields are eligible to render for the buyer's country. The card fields are not eligible in all countries where buyers are located.
        if (paypal.HostedFields.isEligible() === true) {
          paypal.HostedFields.render({
            createOrder: function(data: any, actions: any) {
              // logic to return an order ID from your server
              return fetch(purchaseApiUrl, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "x-csrf-token": csrfToken
                },
                body: JSON.stringify(self.requestBody)
              })
                .then(function(res) {
                  if (!res.ok) {
                    throw new Error(`${res.status} ${res.statusText}`);
                  }
                  return res.json();
                })
                .then(function(data) {
                  return data.data.id;
                })
                .catch(function(res) {
                  location.href = errorUrl + "?type=system_error";
                });
              // return "2260728182S510420";
            },
            styles: this.formStyles,
            fields: this.formFields
          }).then((hostedFields: any) => {
            // 入力チェック
            hostedFields.on("validityChange", (event: any) => {
              const number = event.fields.number;
              const expirationDate = event.fields.expirationDate;
              const cvv = event.fields.cvv;
              // 空欄がなくカード番号がinvalid以外で有効期限とCVVがvalidの場合にsubmitボタンを活性化
              if (
                !(number.isEmpty || expirationDate.isEmpty || cvv.isEmpty) &&
                number.isValid &&
                expirationDate.isValid &&
                cvv.isValid
              ) {
                this.isValid = true;
              } else {
                //それ以外の場合はdisable
                this.isValid = false;
              }
              this.$emit("catch-valid", this.isValid);
            });

            this.hostedFields = hostedFields;
            this.$emit("catch-hosted-fields", this.hostedFields);
          });
        }
      };

      document.body.appendChild(script);
    }
  }
});
